"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
interface OtpInputProps {
  code: string[];
  onChange: (code: string[]) => void;
  inputsRef: React.MutableRefObject<(HTMLInputElement | null)[]>;
  /** @deprecated Use CSS variable --tenant-primary instead. Kept for backward compatibility. */
  primaryColor?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}
export function OtpInput(t0) {
  const $ = _c(16);
  const {
    code,
    onChange,
    inputsRef,
    disabled: t1,
    autoFocus: t2
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const autoFocus = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== code || $[1] !== inputsRef || $[2] !== onChange) {
    t3 = (index, value) => {
      if (value.length > 1) {
        const digits = value.replace(/\D/g, "").slice(0, 6).split("");
        const newOtp = [...code];
        digits.forEach((digit, i) => {
          if (index + i < 6) {
            newOtp[index + i] = digit;
          }
        });
        onChange(newOtp);
        const nextIndex = Math.min(index + digits.length, 5);
        inputsRef.current[nextIndex]?.focus();
      } else {
        const newOtp_0 = [...code];
        newOtp_0[index] = value.replace(/\D/g, "");
        onChange(newOtp_0);
        if (value && index < 5) {
          inputsRef.current[index + 1]?.focus();
        }
      }
    };
    $[0] = code;
    $[1] = inputsRef;
    $[2] = onChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleChange = t3;
  let t4;
  if ($[4] !== code || $[5] !== inputsRef) {
    t4 = (index_0, e) => {
      if (e.key === "Backspace" && !code[index_0] && index_0 > 0) {
        inputsRef.current[index_0 - 1]?.focus();
      }
    };
    $[4] = code;
    $[5] = inputsRef;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleKeyDown = t4;
  let t5;
  if ($[7] !== autoFocus || $[8] !== code || $[9] !== disabled || $[10] !== handleChange || $[11] !== handleKeyDown || $[12] !== inputsRef) {
    t5 = code.map((digit_0, index_1) => <input key={index_1} ref={el => {
      inputsRef.current[index_1] = el;
    }} type="text" inputMode="numeric" maxLength={6} value={digit_0} onChange={e_0 => handleChange(index_1, e_0.target.value)} onKeyDown={e_1 => handleKeyDown(index_1, e_1)} onFocus={_temp} disabled={disabled} className="w-12 h-14 text-center text-xl font-semibold border border-zinc-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-tenant-primary focus:border-transparent disabled:bg-zinc-50 disabled:text-zinc-400" autoFocus={autoFocus && index_1 === 0} />);
    $[7] = autoFocus;
    $[8] = code;
    $[9] = disabled;
    $[10] = handleChange;
    $[11] = handleKeyDown;
    $[12] = inputsRef;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <div className="flex justify-center gap-2">{t5}</div>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(e_2) {
  return e_2.target.select();
}